import { fixedUi } from '@/i18n/fixedUi';
import { tiktokPlatformAPI } from '@/utils/api';

/**
 * 点击「编辑」前校验平台是否允许编辑该商品（TTS 维度为 product_id）。
 * @returns {{ ok: true, spuName: string } | { ok: false, reason: string, spuName: string }}
 */
export async function checkTiktokProductEditable(shopId, spuName) {
  const spu = String(spuName || '').trim();
  if (!shopId) {
    return { ok: false, reason: fixedUi('请先选择店铺'), spuName: spu };
  }
  if (!spu || spu === '—') {
    return { ok: false, reason: fixedUi('缺少产品ID，无法校验是否可编辑'), spuName: spu };
  }
  try {
    const res = await tiktokPlatformAPI.checkEditPermission(shopId, { spuName: spu });
    if (res?.canEdit === false) {
      return {
        ok: false,
        reason: res?.reason || fixedUi('当前商品不可编辑（可能正在审核中）'),
        spuName: spu,
        raw: res,
      };
    }
    return { ok: true, spuName: spu, raw: res };
  } catch (e) {
    return {
      ok: false,
      reason: e?.message || fixedUi('校验是否可编辑失败'),
      spuName: spu,
    };
  }
}
